var SftpEnum;
(function (SftpEnum) {
    SftpEnum["Existing"] = "Existing";
    SftpEnum["New"] = "New";
})(SftpEnum || (SftpEnum = {}));
export var sftpOptions = [
    { label: 'Existing', value: SftpEnum.Existing },
    { label: 'New', value: SftpEnum.New }
];
var LayoutTypeEnum;
(function (LayoutTypeEnum) {
    LayoutTypeEnum["Rightway"] = "Rightway";
    LayoutTypeEnum["Custom"] = "Custom";
    LayoutTypeEnum["_834"] = "834";
    LayoutTypeEnum["_835"] = "835";
    LayoutTypeEnum["_2500_byte_layouts"] = "2500 byte layouts";
})(LayoutTypeEnum || (LayoutTypeEnum = {}));
export var eligibilityVendorLayoutTypeOptions = [
    { label: 'Rightway', value: LayoutTypeEnum.Rightway },
    { label: 'Custom', value: LayoutTypeEnum.Custom },
    { label: '834', value: LayoutTypeEnum._834 },
    { label: '835', value: LayoutTypeEnum._835 },
    {
        label: '2500 byte layouts',
        value: LayoutTypeEnum._2500_byte_layouts
    }
];
export var accumulatorVendorLayoutTypeOptions = [
    { label: 'Rightway', value: LayoutTypeEnum.Rightway },
    { label: 'Custom', value: LayoutTypeEnum.Custom }
];
export var claimFilesVendorLayoutTypeOptions = [
    { label: 'Rightway', value: LayoutTypeEnum.Rightway },
    { label: 'Custom', value: LayoutTypeEnum.Custom }
];
var IDCardTypeEnum;
(function (IDCardTypeEnum) {
    IDCardTypeEnum["RightwayOnly"] = "Rightway Only";
    IDCardTypeEnum["Dual"] = "Dual Medical/Pharmacy";
})(IDCardTypeEnum || (IDCardTypeEnum = {}));
export var idCardTypeOptions = [
    { label: 'Rightway Only', value: IDCardTypeEnum.RightwayOnly },
    { label: 'Dual Medical/Pharmacy', value: IDCardTypeEnum.Dual }
];
export var requiredOptions = [
    { label: 'Yes', value: true },
    { label: 'No', value: false }
];
var processingTypeEnum;
(function (processingTypeEnum) {
    processingTypeEnum["API"] = "API";
    processingTypeEnum["FlatFile"] = "Flat File";
})(processingTypeEnum || (processingTypeEnum = {}));
export var processingOptions = [
    { label: 'API', value: processingTypeEnum.API },
    { label: 'Flat File', value: processingTypeEnum.FlatFile }
];
var NewImplementationAttachmentTypeEnum;
(function (NewImplementationAttachmentTypeEnum) {
    NewImplementationAttachmentTypeEnum["Layout"] = "Layout";
    NewImplementationAttachmentTypeEnum["GroupStructure"] = "Group Structure";
    NewImplementationAttachmentTypeEnum["Hierarchy"] = "Hierarchy";
})(NewImplementationAttachmentTypeEnum || (NewImplementationAttachmentTypeEnum = {}));
export var newImplementationAttachmentOptions = [
    { label: 'Layout', value: NewImplementationAttachmentTypeEnum.Layout },
    {
        label: 'Group Structure',
        value: NewImplementationAttachmentTypeEnum.GroupStructure
    },
    { label: 'Hierarchy', value: NewImplementationAttachmentTypeEnum.Hierarchy }
];
export var newImplementationAttachmentLayoutOnly = [
    { label: 'Layout', value: NewImplementationAttachmentTypeEnum.Layout }
];
var idCardsAttachmentTypeEnum;
(function (idCardsAttachmentTypeEnum) {
    idCardsAttachmentTypeEnum["Logos"] = "Logos";
    idCardsAttachmentTypeEnum["DraftIDCards"] = "Draft ID Cards";
})(idCardsAttachmentTypeEnum || (idCardsAttachmentTypeEnum = {}));
export var newImplementationAttachmentIDCardOptions = [
    { label: 'Logos', value: idCardsAttachmentTypeEnum.Logos },
    { label: 'Draft ID Cards', value: idCardsAttachmentTypeEnum.DraftIDCards }
];
